// src/router/layoutRoutes.ts
import { RouteRecordRaw } from 'vue-router';
import Layout from '@/components/Layout.vue';

import MngOrgnization from '@/components/pages/MngOrgnization.vue';
import MngDepartment from '@/components/pages/MngDepartment.vue';
import MngUser from '@/components/pages/MngUser.vue';
import MngCategory from '@/components/pages/MngCategory.vue';
import MngMaterial from '@/components/pages/MngMaterial.vue';
import MngSettings from '@/components/pages/MngSettings.vue';
import MngInventory from '@/components/pages/MngInventory.vue';
import MngInventory2 from '@/components/pages/MngInventory2.vue';
import MngAlert from '@/components/pages/MngAlert.vue';
import MngLog from '@/components/pages/MngLog.vue';
import PersonalSetting from '@/components/pages/PersonalSetting.vue';
import MngJancode from '@/components/pages/MngJancode.vue';
import { ROUTES } from '@/config/constants';
import MngCheckResult from '@/components/pages/MngCheckResult.vue';
import MngConstantManage2 from '@/components/pages/MngConstantManage2.vue';
import MngPayment from '@/components/pages/MngPayment.vue';
/**
 * 用于Element-Plus 学习调查用的临时路由
 */
const layoutRoutes: Array<RouteRecordRaw> = [
    {
        path: '/',
        component: Layout,
        children: [
            {
                path: ROUTES.ALARM,
                name: 'Alarm',
                component: MngCheckResult,
                meta: { requiresAuth: true }
            },
            {
                path: ROUTES.USER,
                name: 'User',
                component: MngUser,
                meta: { requiresAuth: true }
            },
            {
                path: ROUTES.INVENTORY,
                name: 'Inventory',
                component: MngInventory,
                meta: { requiresAuth: true }
            },
            {
                path: ROUTES.INVENTORY2,
                name: 'Inventory2',
                component: MngInventory2,
                meta: { requiresAuth: true }
            },
            {
                path: ROUTES.PAYMENT,
                name: 'Payment',
                component: MngPayment,
                meta: { requiresAuth: true }
            },
            {
                path: ROUTES.CONSTANT_MANAGE2,
                name: 'ConstantManage2',
                component: MngConstantManage2,
                meta: { requiresAuth: true }
            },
            {
                path: ROUTES.CHECK_RESULT,
                name: 'CheckResult',
                component: MngAlert,
                meta: { requiresAuth: true }
            },
            {
                path: ROUTES.MATERIAL,
                name: 'Material',
                component: MngMaterial,
                meta: { requiresAuth: true }
            },
            {
                path: ROUTES.ORGANIZATION,
                name: 'Organization',
                component: MngOrgnization,
                meta: { requiresAuth: true }
            },
            {
                path: ROUTES.DEPARTMENT,
                name: 'Department',
                component: MngDepartment,
                meta: { requiresAuth: true }
            },
            {
                path: ROUTES.CATEGORY,
                name: 'Category',
                component: MngCategory,
                meta: { requiresAuth: true }
            },
            {
                path: ROUTES.LOG,
                name: 'Log',
                component: MngLog,
                meta: { requiresAuth: true }
            },
            {
                path: ROUTES.SETTINGS,
                name: 'Settings',
                component: MngSettings,
                meta: { requiresAuth: true }
            },
            {
                path: ROUTES.JANCODE,
                name: 'Jancode',
                component: MngJancode,
                meta: { requiresAuth: true }
            },
            {
                path: ROUTES.PERSONAL_SETTINGS,
                name: 'PersonalSetting',
                component: PersonalSetting,
                meta: { requiresAuth: true }
            }
        ]
    }
];

export default layoutRoutes;